module.exports = __webpack_public_path__ + "index/img/default.6b914f9c.jpg";